<template>
  <tr>
    <td>{{ table.id }}</td>
    <td>{{ table.title }}</td>
    <td>
      <span :class="{ 'text-green': remaining>0, 'text-danger': remaining<1 }">
       {{ getRemaining() }}
      </span>
    </td>
    <td>{{ shoeId }}</td>
    <td>{{ round }}</td>
    <td>
      <span :class="{'text-green': status==='BETTING' }">
        {{ getStatus() }}
      </span>
      <span v-if="visibleTakeResult[gameKey] && statusMachine" class="text-info">
        <br/> {{ statusMachine }}
      </span>
    </td>
    <td>{{ gameId }}</td>
    <td>
      <button type="button" class="btn btn-success btn-xs" @click="handleOnClickStartGame()">Start game</button>
      <button type="button" class="btn btn-danger btn-xs" @click="handleOnClickForceEndGame()">Force end game</button>
      <button type="button" class="btn btn-primary btn-xs" @click="handleOnClickTakeResults()" v-if="!visibleTakeResult[gameKey]">Take result</button>
      <button type="button" class="btn btn-success btn-xs" @click="handleOnClickStartShoe()">Start Shoe</button>
      <button type="button" class="btn btn-danger btn-xs" @click="handleOnClickEndShoe()">End Shoe</button>

    </td>

  </tr>
</template>
<script>

  import requestInterval from 'request-interval'

  const Visibility = require('visibilityjs')

  export default {
    name: 'games-machine',
    props: {
      userId: {
        required: true,
        type: [String, Number]
      },
      table: {
        required: true,
        type: Object
      },
      gameKey: {
        required: true,
        type: String
      },
    },
    data() {
      return {
        timerInt: {},
        remaining: 0,
        gameData: {},
        shoeId: '',
        round: '',
        gameId: '',
        status: '',
        statusMachine:'',
        gameKeyMap: {
          keno: 'keno',
          keno_classic: 'keno',
          pokdeng_machine: 'pokdeng',
        },
        visibleTakeResult: {
          pokdeng_machine: 1
        }

      }
    },
    mounted() {
      this.status = this.table.status
      this.shoeId = this.table.shoe_id
      this.gameId = this.table.game_id

      this.fetch()
      this.getCurrentGame()
      this.timer()
      Visibility.change(function (e, state) {
        this.getCurrentGame()
        this.timer()
      }.bind(this))
    },
    methods: {
      fetch() {
        const table = this.table.id
        const channels = pusher.subscribe('game.' + table)
        channels.broadcast = pusher.subscribe('presence-table.' + table)
        // พนักงานประจำโต๊ะ start a new game.
        channels.bind('start', (data) => {
          this.setDataGame(data)

        }).bind(this)

//        channels.bind('bets', (data) => {
//            this.receiveพนักงานประจำโต๊ะBets(data, table)
//        }).bind(this)
        // Something change we need to get current.
        channels.bind('changed', (data) => {
          this.getCurrentGame()
        }).bind(this)

        channels.bind('result', (data) => {
          console.dir(data)
        }).bind(this)

//        channels.bind('force-shutdown', (data) => {
//          this.getCurrentGame()
//        }).bind(this)

//        channels.bind('end-shoe', (data) => {
//          this.setDataGame(data)

//        }).bind(this)

        //User online from server.
//        channels.broadcast.bind('online', (number) => {
//            this.updateGameOnline(number, table)
//        }).bind(this)
        channels.bind('machine-pokdeng', (data) => {
//          console.dir(data)
          this.statusMachine = data
        }).bind(this)
      },
      getCurrentGame() {
        axios.get(`/${this.gameKeyMap[this.gameKey]}/${this.table.id}/current`)
          .then(response => {
            if (_.has(response.data, 'code')) {
//              this.status = response.data.error
              return
            }
            if (response.data) {
              this.setDataGame(response.data.game)
            }
          })
          .catch(err => {
            if (typeof errorCb === 'function') {
              console.log(err)
            }
          })
      },
      setDataGame(data) {
        this.gameData = data
        this.remaining = _.get(this.gameData, 'remaining', 0)
        this.round = _.get(this.gameData, 'round', '-')
        this.shoeId = _.get(this.gameData, 'shoe_id', '-')
        this.status = _.get(this.gameData, 'status', '-')
        this.gameId = _.get(this.gameData, 'id', '-')
      },
      timer() {
        requestInterval.clear(this.timerInt)
        if (_.isInteger(this.remaining)) {
          this.timerInt = requestInterval(1000, () => {
            this.remaining--
          })
        }
      },
      handleOnClickStartGame() {
        const request = {
          table_id: this.table.id,
          betting: 1
        }
        axios.post(`/${this.gameKeyMap[this.gameKey]}`, request)
          .then(response => {
            console.log(response)

          })
          .catch(err => {
            if (typeof errorCb === 'function') {
              console.log(err)

            }
            this.$notify.error({
              message: _.get(err.response, 'data.0.message', '') + _.get(err.response, 'data.error', ''),
              offset: 50,
              duration: 10000
            })
          })
      },
      handleOnClickForceEndGame() {
        axios.post(`/${this.gameKeyMap[this.gameKey]}/${this.table.id}/forceendgame`)
          .then(response => {
            this.setDataGame()
            this.status = 'Shoe:OPEN'
            this.gameId = 'CLOSED'
          })
          .catch(err => {
            if (typeof errorCb === 'function') {
              console.log(err)
            }
            this.$notify.error({
              message: _.get(err.response, 'data.0.message', '') + _.get(err.response, 'data.error', ''),
              offset: 50,
              duration: 10000
            })
          })
      },
      handleOnClickStartShoe() {
        const request = {
          table_id: this.table.id
        }
        axios.post(`${this.gameKeyMap[this.gameKey]}/${request.table_id}/startshoe`, request)
          .then(response => {
            this.setDataGame()
            this.status = 'Shoe:OPEN'
            this.gameId = 'CLOSED'
            this.shoeId = response.data.shoe_id
          })
          .catch(err => {
            if (typeof errorCb === 'function') {
              console.log(err)
            }
            this.$notify.error({
              message: _.get(err.response, 'data.0.message', '') + _.get(err.response, 'data.error', ''),
              offset: 50,
              duration: 10000
            })
          })
      },
      handleOnClickEndShoe() {

        const request = {
          table_id: this.table.id
        }
        axios.post(`${this.gameKeyMap[this.gameKey]}/${request.table_id}/endshoe`, request)
          .then(response => {
            this.setDataGame()
            this.status = 'Shoe:CLOSED'
            this.gameId = 'CLOSED'
          })
          .catch(err => {
            if (typeof errorCb === 'function') {
              console.log(err)
            }
            this.$notify.error({
              message: _.get(err.response, 'data.0.message', '') + _.get(err.response, 'data.error', ''),
              offset: 50,
              duration: 10000
            })
          })
      },
      handleOnClickTakeResults() {
        const request = {
          table_id: this.table.id,
          id: this.gameId,
          request_id: this.table.id,
          status: 'open'
        }

        axios.post(`${this.gameKeyMap[this.gameKey]}/deal`, request)
          .then(response => {
            this.remaining = null
          })
          .catch(err => {
            if (typeof errorCb === 'function') {
              console.log(err)
            }
            this.$notify.error({
              message: _.get(err.response, 'data.0.message', '') + _.get(err.response, 'data.error', ''),
              offset: 50,
              duration: 10000
            })
          })
      },
      getRemaining() {
        if (this.shoeId === 'CLOSED' || this.gameId === 'CLOSED') {
          return ''
        }
        return this.remaining
      },
      getStatus() {
        if (this.shoeId > 0 && this.remaining < 1 && this.gameId !== 'CLOSED') {
          return this.status = 'TIME OUT'
        }
        return this.status
      },

    },
  }
</script>



// WEBPACK FOOTER //
// resources/assets/js/admin/components/games-machine/control.vue